// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__CZXxU","input":"Search_input__MUhPA","icon":"Search_icon__+lvc-","clear":"Search_clear__t0ckb"};